import { FileInfo } from "@/components/common/FileInfo/FileInfo"
import { Typography } from "@/components/common/Typography/Typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Questionnaire } from "@/types/questionnaire/models"

interface ActionSidebarRightProps {
  questionnaire: Questionnaire
  handleOpenDeleteModal: () => void
  actionButtons?: React.ReactElement
  fileInfoActionDisabled?: boolean
  isLoading?: boolean
}

export const ActionSidebarRight: React.FC<ActionSidebarRightProps> = ({
  questionnaire,
  handleOpenDeleteModal,
  actionButtons,
  fileInfoActionDisabled = false,
  isLoading = false,
}) => {
  const { translate } = useTranslation()
  return (
    <div className="space-y-6">
      <Typography as="h2" variant="textM">
        {translate("QUESTIONNAIRE/YOUR_QUESTIONNAIRE")}
      </Typography>
      <FileInfo
        fileTitle={questionnaire?.fileName || ""}
        deleteButton
        status={questionnaire.status}
        onDelete={handleOpenDeleteModal}
        disabled={fileInfoActionDisabled}
        isLoading={isLoading}
      ></FileInfo>

      {actionButtons}
    </div>
  )
}
